import ModuleCreate from '../views/ModuleCreate'

const ModuleCreateContainer = () => {
  return <ModuleCreate />
}

export default ModuleCreateContainer
